import React from 'react';
import ModalWrapper from '../../elements/ModalWrapper';
import { Avatar, Divider, Flex, Image, Stack, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { getSharepointCdnFileMedia } from '../../../utilities';

interface ModalTestimonyDetailProps {
  isVisible: boolean;
  photo: string;
  shortDescription: string;
  name: string;
  courseName: string;
  position: string;
  title: string;
  unit: string;
  content: any;
  video?: string;
  onClose: () => void;
}

const ModalTestimonyDetail: React.FC<ModalTestimonyDetailProps> = ({
  isVisible,
  shortDescription,
  photo,
  courseName,
  name,
  position,
  content,
  title,
  unit,
  video,
  onClose
}) => {
  const renderVideo = () => {
    const winHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    return (
      <div className="" style={{ textAlign: 'center' }}>
        <video
          style={{ height: '100%', width: '100%' }}
          controls
          src={getSharepointCdnFileMedia(video)}
        ></video>
      </div>
    );
  };

  const smScreen = useMediaQuery('(max-width: 48em)');
  return (
    <ModalWrapper
      title={'Testimony'}
      isVisible={isVisible}
      onClose={onClose}
      size="lg"
    >
      <Divider my={16} />
      <Text fz={16} fw={600}>
        {courseName}
      </Text>
      <Flex gap={16} mt={16}>
        <Flex direction={'column'} gap={10} flex={1}>
          <Text fz={14} fw={500} my={10}>
            "{shortDescription}"
          </Text>
          <section>
            <Text style={{ whiteSpace: 'pre-line' }}>{content}</Text>
            {/* <div dangerouslySetInnerHTML={{ __html: content }} /> */}
          </section>
          {video && renderVideo()}
        </Flex>
        <Stack maw={200}>
          <Avatar alt={name} src={photo} size={smScreen ? 'xl' : 100} />
          <Stack gap={0}>
            <Text fz={14} fw={700}>
              {name}
            </Text>
            <Text fz={14} fw={500} c={'gray'}>
              {position}
            </Text>
            <Text fz={14} fw={500} c={'gray'}>
              {unit}
            </Text>
          </Stack>
        </Stack>
      </Flex>
    </ModalWrapper>
  );
};

export default ModalTestimonyDetail;
